import React from 'react';
import { useLocation } from 'react-router-dom';
import ChatShell from '../../components/chat/ChatShell';
import PageHeader from '../../components/common/PageHeader';

const AdminChatPage: React.FC = () => {
  // One Chat page serves both surfaces; the path line follows the one you're on.
  const isLearnerSurface = useLocation().pathname.startsWith('/learn');
  return (
    <div className="flex h-[calc(100vh-72px-3rem)] flex-col">
      <PageHeader
        title="Chat"
        root={isLearnerSurface ? { label: 'Home', to: '/learn/dashboard' } : undefined}
        className="mb-4 shrink-0"
      />
      <div className="min-h-0 flex-1">
        <ChatShell variant="admin" />
      </div>
    </div>
  );
};

export default AdminChatPage;
